import React from 'react';
import PropTypes from 'prop-types';
import MdClose from '@meronex/icons/md/MdClose';

import { useTheme } from '@material-ui/core';

export default function CloseBtn(props) {
  const theme = useTheme();

  return (
    <div
      style={{
        fontSize: '25px',
        position: 'absolute',
        float: 'right',
        display: 'inline-block',
        color: theme.palette.text.primary,
        cursor: 'pointer',
        zIndex: '4',
        right: '0',
        width: '80px',
        height: '50px',
        textAlign: 'center',
        top: '0',
        paddingTop: '15px',
      }}
      onClick={(e) => {
        if (props.onClick) {
          props.onClick(e);
        }
      }}>
      <MdClose />
    </div>
  );
}

CloseBtn.propTypes = {
  onClick: PropTypes.func,
};
